import { Space } from 'antd'
import { EmailTemplateButton } from './EmailTemplateButton'

const PostEventHandson = function () {
  return <Space size='small' orientation='vertical'>
    <p>Hands-on post-event email templates</p>
    <EmailTemplateButton
      type='Post-event - Hands-on'
      title='Hands-on post event email template'
      settingKey='post-session.hands-on.closure' />
  </Space>
}

export default PostEventHandson
